module.exports = __webpack_public_path__ + "static/media/coffeescript.188980bf.svg";